import React, { Component } from 'react';
import style from './index.module.css';
import 'tiny-date-picker/tiny-date-picker.min.css';
import 'tiny-date-picker/date-range-picker.min.css';
import './tiny-date-picker.custom.global.css';
import { connectRange } from 'react-instantsearch-dom';
import { DateRangePicker } from 'tiny-date-picker/dist/date-range-picker';

type CustomRangeInputProps = {
    currentRefinement: {
        min: number;
        max: number;
    };
    refine(value?: { min: number; max: number }): void;
};

interface HTMLInputEvent extends Event {
    target: HTMLInputElement & EventTarget;
}

class RangeInput extends Component<CustomRangeInputProps> {
    startInputEl: HTMLInputElement;
    endInputEl: HTMLInputElement;
    pickerEl: HTMLElement;

    componentDidMount() {
        const updateInputs = (startDate: Date, endDate: Date) => {
            this.startInputEl.value = startDate?.toLocaleDateString() || '';
            this.endInputEl.value = endDate?.toLocaleDateString() || '';
        };

        // Initialize picker plugin
        const picker: any = DateRangePicker(this.pickerEl);

        // By default the picker inputs should range from
        // "today" and "a year from today"
        const today = new Date();
        const yearFromToday = new Date(new Date().setFullYear(today.getFullYear() + 1));
        picker.setState({
            start: today,
            end: yearFromToday,
        });
        updateInputs(today, yearFromToday);

        // Interactions with the picker will update the
        // inputs and refine the search
        picker.on('statechange', () => {
            const start: Date = picker.state.start;
            const startUTC: number = start && start.getTime();

            const end: Date = picker.state.end;
            const endUTC: number = end && end.getTime();

            updateInputs(start, end);

            this.props.refine({
                ...this.props.currentRefinement,
                min: startUTC,
                max: endUTC,
            });

            if (picker.state.start && picker.state.end) {
                this.pickerEl.dataset.hidden = '';
            }
        });

        // Show/hide picker at the right times
        const updatePickerVisibility = ((evt: HTMLInputEvent) => {
            if (evt.type === 'focus') {
                delete this.pickerEl.dataset.hidden;
            } else if (
                evt.target !== this.startInputEl &&
                evt.target !== this.endInputEl &&
                !evt.target.className?.includes('dp')
            ) {
                this.pickerEl.dataset.hidden = '';
            }
        }).bind(this);

        this.startInputEl.addEventListener('focus', updatePickerVisibility);
        this.endInputEl.addEventListener('focus', updatePickerVisibility);
        // For clicks outside to close the picker
        document.addEventListener('click', updatePickerVisibility);
    }

    render() {
        // This component should render only once and then
        // the picker's statechange events will take over
        return (
            <>
                <div className={style.filterInputs}>
                    <label>
                        <span>From:</span>
                        <input readOnly ref={(ref) => (this.startInputEl = ref)} type="text" />
                    </label>
                    <label>
                        <span>To:</span>
                        <input readOnly ref={(ref) => (this.endInputEl = ref)} type="text" />
                    </label>
                </div>
                <div className={style.datePickerWrapper} data-hidden ref={(ref) => (this.pickerEl = ref)} />
            </>
        );
    }
}

const CustomDateRangeInput = connectRange(RangeInput);

type Props = {
    attribute: string;
    label: string;
};

const WrappedFilter = ({ attribute, label }: Props) => {
    return (
        <div className={style.filterWrapper}>
            <div className={style.accordionHeader}>{label}</div>
            <CustomDateRangeInput attribute={attribute} />
        </div>
    );
};

export default WrappedFilter;
